import * as React from 'react';
import { Button, Typography } from '../common';
import { CaseInquiredAbout } from '@/interfaces';
import Icons from '@/const/icons';
import { Textarea } from '../form';
import { FieldValues, useForm } from 'react-hook-form';
import { ConversationHeader } from '../screens/dashboard/inbox';
import { Subjects } from '@/interfaces/inbox';
import { useRouter } from 'next/router';
import AppRoutes from '@/const/routes';

interface WhiteNewEmailProps {
	to: string;
	clientSelected?: {
		id: string;
		name: string;
		last_name?: string;
		profile_picture: string;
	};
	category: CaseInquiredAbout;

	caseTitle: string;
	subject: Subjects;
	isYourLawyer?: boolean;
	isLoading?: boolean;
	textareaRef?: any;
	isMobile?: boolean;
	handleContentSubmit: (value: FieldValues) => void;
	handleTextareaFocus?: () => void;
}

export const WriteNewEmail: React.FC<WhiteNewEmailProps> = ({
	to,
	clientSelected,
	caseTitle,
	category,
	subject,
	isYourLawyer = false,
	isLoading,
	textareaRef,
	isMobile,
	handleContentSubmit,
	handleTextareaFocus,
}) => {
	const router = useRouter();
	const pathname = router.pathname;
	const [countWords, setCountWords] = React.useState(0);
	const maxWords = 1000;

	const {
		register,
		formState: { errors, isDirty, isValid },
		handleSubmit,
	} = useForm();

	const rules = {
		message: {
			required: { value: true, message: 'This is required.' },
		},
	};

	const isClient = pathname.includes(AppRoutes.CLIENTAPP);

	return (
		<form
			className="lg:w-[656px] h-full flex flex-col"
			onSubmit={handleSubmit(handleContentSubmit)}
		>
			<ConversationHeader
				caseTitle={caseTitle}
				category={category}
				subject={subject.title}
				to={{
					firstname: to,
					lastname: clientSelected?.last_name || '',
					profile_picture: clientSelected?.profile_picture || '',
				}}
				isYourLawyer={isYourLawyer}
			/>
			<div className="flex-1 overflow-y-auto">
				<Textarea
					name="message"
					register={register}
					placeholder="Write your message here"
					rules={rules.message}
					error={errors.message}
					rows={isMobile ? 7 : 5}
					// className="h-full"
					classNameContainerInput="border-0 rounded-none mb-4"
					classNameInput="!rounded-none !bg-transparent !px-0 !py-0 lg:min-h-[350px]"
					maxLength={isClient ? 1000 : undefined}
					onChangeCustom={({ target }) =>
						setCountWords((target as any)?.value.length)
					}
					textAreaRef={textareaRef}
					onFocus={handleTextareaFocus}
				/>
			</div>
			<div className="flex flex-row-reverse lg:flex-row items-center justify-between pb-[env(safe-area-inset-bottom)]">
				<Button
					decoration="primary"
					label="Send"
					size="extra-small"
					icon={Icons.sendEmail}
					iconRight
					disabled={!isValid || !isDirty || isLoading}
					className="!py-4 max-w-fit lg:max-w-full"
					type="submit"
				/>
				{isClient && (
					<div className="flex items-center text-xs">
						<Typography type="regular-12" className="text-grey-50">
							{`${countWords}`}
						</Typography>
						<span className="text-grey-50">/</span>
						<Typography type="regular-12" className="text-grey-50">
							{`${maxWords}`}
						</Typography>
					</div>
				)}
			</div>
		</form>
	);
};
